import { useQuery } from '@tanstack/react-query';
import { getFileStatus } from '../api/files';
import { useAuthStore } from '../store/auth.store';

const POLL_INTERVAL = 3_000;

export function useFileStatus(fileGUID: string | undefined, enabled = true) {
  const userGUID = useAuthStore((s) => s.user?.guid);

  return useQuery({
    queryKey: ['file-status', userGUID, fileGUID],
    queryFn: () => {
      if (!userGUID || !fileGUID) throw new Error('missing guid');
      return getFileStatus(userGUID, fileGUID);
    },
    enabled: Boolean(userGUID && fileGUID && enabled),
    // Поллим только пока сервер реально что-то делает. SELECT_PAGES — ждём
    // действия юзера, COMPLETED/FAILED — финальные состояния.
    refetchInterval: (query) => {
      const status = query.state.data?.status;
      if (status === 'INIT' || status === 'IN_PROGRESS') return POLL_INTERVAL;
      return false;
    },
    refetchIntervalInBackground: false,
  });
}
